/**
 *  !!! VERY IMPORTANT !!!
 * there is a copy of this file at  /server/utils/encode-special-characters.js used when
 * sending orders to TextBroker; both files should be kept in sync
 * 
 * @param {string}
 * @returns {string}
 */
export const encodeSpecialCharacters = (inputString) => {
  if (typeof inputString !== 'string') {
    return inputString;
  }

  const encodingMap = {
    '&': '&amp;',   // Must be first to prevent double-encoding
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '+': '&#43;',
    '!': '&#33;',
    '@': '&#64;',
    '#': '&#35;',
    '$': '&#36;',
    '%': '&#37;',
    '^': '&#94;',
    '*': '&#42;',
    '(': '&#40;',
    ')': '&#41;',
    '_': '&#95;',
    '[': '&#91;',
    ']': '&#93;',
    '/': '&#47;'
  };

  return inputString.replace(/[&<>'"#+!@$%^*()_\[\]\/]/g, char => encodingMap[char]);
};
